import type { Editor } from "@tiptap/react";

const MARKDOWN_PUNCTUATION = /[\\`*_{}[\]()#+\-.!<>|~]/g;

export function plainToMarkdown(text: string): string {
  return text.replace(MARKDOWN_PUNCTUATION, "\\$&");
}

export function toEditorMarkdown(body: string, format: "Markdown" | "Plain"): string {
  return format === "Markdown" ? body : plainToMarkdown(body);
}

export function appendMarkdown(current: string, addition: string): string {
  const extra = addition.trim();
  if (!extra) return current;
  const base = current.trimEnd();
  return base ? `${base}\n\n${extra}` : extra;
}

export function markdownOf(editor: Editor): string {
  const storages = editor.storage as unknown as Record<string, { getMarkdown?: () => string }>;
  return storages.markdown?.getMarkdown?.() ?? "";
}

const SAFE_PROTOCOLS = ["http:", "https:", "mailto:", "tel:"];
const SCHEME = /^[a-z][a-z0-9+.-]*:/i;
const EMAIL = /^[^\s@/?#]+@[^\s@/?#]+\.[^\s@/?#]+$/;

export function normalizeHref(raw: string): string | null {
  const trimmed = raw.trim();
  if (!trimmed) return null;
  const candidate = SCHEME.test(trimmed)
    ? trimmed
    : EMAIL.test(trimmed)
      ? `mailto:${trimmed}`
      : `https://${trimmed}`;
  try {
    const url = new URL(candidate);
    return SAFE_PROTOCOLS.includes(url.protocol.toLowerCase()) ? candidate : null;
  } catch {
    return null;
  }
}

export function openHref(raw: string): boolean {
  const href = normalizeHref(raw);
  if (!href) return false;
  const protocol = new URL(href).protocol.toLowerCase();
  if (protocol === "mailto:" || protocol === "tel:") {
    window.location.href = href;
    return true;
  }
  window.open(href, "_blank", "noopener,noreferrer");
  return true;
}
